export const API_URL = 'https://desolate-lowlands-17022.herokuapp.com'



// WEBPACK FOOTER //
// ./src/urls.js